export default [
	{
		key: 'name',
		title: 'Name',
		scopedSlots: {customRender: 'name'}
	}, {
		key: 'contact',
		title: 'Contact',
		scopedSlots: {customRender: 'contact'}
	}, {
		dataIndex: 'available_drivers',
		key: 'drivers',
		title: 'Drivers',
		scopedSlots: {customRender: 'drivers'}
	}, {
		dataIndex: 'balance',
		key: 'balance',
		title: 'Balance',
		scopedSlots: {customRender: 'balance'}
	}, {
		dataIndex: 'updated_at',
		key: 'updated_at',
		title: 'Last Updated',
		slots: {title: 'updateTitle'},
		scopedSlots: {customRender: 'updated_at'}
	}, {
		title: '',
		key: 'action',
		align: 'right',
		width: 180,
		scopedSlots: {customRender: 'action'}
	}
]
